/*
  Rendering layer: the components that put pixels on screen, kept apart from @puzzlio/core so that
  core stays free of any renderer.

  Today these are the DOM implementations. When the native shim lands, this entry point becomes a
  conditional export — `react-native` for Metro, `default` for the web bundlers — and each component
  gains a sibling implementation built on react-native-svg / Reanimated.
*/
export * from './AnimationPresence';
export * from './backgroundSubscription';
export * from './GestureSurface';
export * from './puzzleGrid';
export * from './animation';
export * from './primitives';
export * from './Presence';
export * from './PressFill';
export * from './Animate';
export * from './Label';
export * from './Pressable';
